import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Hit, OrderByTypeEnum } from '../../../../../interfaces/src/lib/types/index';
import { getQueryParamIgnoreCase } from '../../utilFuncs/utilFuncs';

type SelectedCruiseCard = Hit | null;

export interface CruiseCardState {
  selectedCruiseCard: SelectedCruiseCard;
  isLayerOpen: boolean;
  orderBy: OrderByTypeEnum;
  portCharges?: string;
  nightsLabels: {
    numberOfNightsLabel?: string;
    numberOfSingleNightLabel?: string;
  };
  hscFeeCharges?: string;
}

const viewPriceBasedOnPriceRange = getQueryParamIgnoreCase(
  window.location.search,
  'priceRangeView'
);

let viewPriceType = OrderByTypeEnum.PERSON;

if (
  viewPriceBasedOnPriceRange &&
  (viewPriceBasedOnPriceRange === OrderByTypeEnum.PERSON ||
    viewPriceBasedOnPriceRange === OrderByTypeEnum.CABIN)
) {
  viewPriceType = viewPriceBasedOnPriceRange;
}
const initialState: CruiseCardState = {
  selectedCruiseCard: null,
  isLayerOpen: false,
  orderBy: viewPriceType,
  portCharges: '',
  nightsLabels: {
    numberOfNightsLabel: '',
    numberOfSingleNightLabel: '',
  },
  hscFeeCharges: '',
};

const cruiseCardSlice = createSlice({
  name: 'cruiseCard',
  initialState,
  reducers: {
    setSelectedCruiseCard: (state, action: PayloadAction<SelectedCruiseCard>) => {
      state.selectedCruiseCard = action.payload;
    },
    setIsLayerOpen: (state, action: PayloadAction<boolean>) => {
      state.isLayerOpen = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<OrderByTypeEnum>) => {
      state.orderBy = action.payload;
    },
    setPortCharges: (state, action: PayloadAction<string | undefined>) => {
      state.portCharges = action.payload;
    },
    setHscFeeCharges: (state, action: PayloadAction<string | undefined>) => {
      state.hscFeeCharges = action.payload;
    },
    setNightsLabels: (
      state,
      action: PayloadAction<{
        numberOfNightsLabel?: string;
        numberOfSingleNightLabel?: string;
      }>
    ) => {
      state.nightsLabels = action.payload;
    },
  },
});

export const {
  setSelectedCruiseCard,
  setIsLayerOpen,
  setOrderBy,
  setPortCharges,
  setHscFeeCharges,
  setNightsLabels,
} = cruiseCardSlice.actions;
export default cruiseCardSlice.reducer;
